import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { Button } from './components/ui/button';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white" data-testid="terms-of-service-page">
      <header className="sticky top-0 z-50 w-full border-b bg-white shadow-sm">
        <div className="container flex h-16 items-center">
          <a href="/">
            <Button variant="ghost" className="gap-2 text-royal-maroon" data-testid="back-home-btn">
              <ArrowLeft className="h-4 w-4" /> Back to Home
            </Button>
          </a>
        </div>
      </header>

      <main className="container max-w-3xl py-12 px-4">
        <h1 className="text-3xl font-serif font-bold text-gray-900 mb-8">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: March 30, 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing and using the website www.royalsteelfurniture.in operated by Royal Life Steel Furniture Pvt Ltd, you agree to comply with and be bound by these Terms of Service. If you do not agree, please do not use our website.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">2. About Us</h2>
            <p>Royal Life Steel Furniture Pvt Ltd is a manufacturer of steel almirahs and office furniture based in Nagpur, Maharashtra, India. We have been in operation since 1993, serving customers across Central India through a network of 300+ authorized dealers.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">3. Products and Services</h2>
            <p>The product images, specifications, and descriptions on this website are for informational purposes. While we strive to keep information accurate:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Actual product colours may vary slightly from images displayed</li>
              <li>Specifications and dimensions are approximate and subject to manufacturing tolerances</li>
              <li>Prices are not listed on the website; please contact us for current pricing</li>
              <li>Product availability may vary by region</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">4. Enquiries and Orders</h2>
            <p>Submitting an enquiry through our website does not constitute an order or contract. All orders are subject to confirmation, pricing, and availability as communicated directly by our sales team via phone or WhatsApp.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">5. Intellectual Property</h2>
            <p>All content on this website, including text, images, logos, product photographs, and videos, are the property of Royal Life Steel Furniture Pvt Ltd and are protected by applicable copyright and trademark laws. You may not reproduce, distribute, or use our content without written permission.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">6. User Conduct</h2>
            <p>When using our website, you agree not to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Submit false or misleading information</li>
              <li>Attempt to gain unauthorized access to our systems</li>
              <li>Use the website for any unlawful purpose</li>
              <li>Interfere with the proper functioning of the website</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">7. Limitation of Liability</h2>
            <p>Royal Life Steel Furniture Pvt Ltd shall not be liable for any indirect, incidental, or consequential damages arising from the use of this website. Our liability is limited to the maximum extent permitted by applicable Indian law.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">8. Governing Law</h2>
            <p>These Terms of Service are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Nagpur, Maharashtra.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">9. Changes to Terms</h2>
            <p>We reserve the right to modify these Terms of Service at any time. Changes will be effective immediately upon posting on this page. Your continued use of the website constitutes acceptance of any modifications.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mt-8 mb-3">10. Contact Us</h2>
            <p>For any questions about these Terms of Service, please contact us at:</p>
            <p className="mt-2">
              <strong>Royal Life Steel Furniture Pvt Ltd</strong><br />
              Near S.T. Workshop, Dalda Factory Square,<br />
              New Cotton Market Rd, Ghat Road,<br />
              Nagpur, Maharashtra 440018<br />
              Phone: +91 9373102545<br />
              GST: 27AADCR9622B1ZI
            </p>
          </section>
        </div>
      </main>
    </div>
  );
}
